export enum WidgetLayout {
  Default = 'Default',
  Horizontal = 'Horizontal',
  Vertical = 'Vertical'
}
